var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading ? _c("j-loading-table") : _vm._e(),
      _vm._v(" "),
      _c(
        "v-client-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading"
            }
          ],
          staticClass: "jTable",
          attrs: {
            data: _vm.data_group_apps,
            columns: _vm.columns_group,
            options: _vm.table_options_group
          },
          scopedSlots: _vm._u([
            {
              key: "id",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.detailGroup(props.row.id)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(props.row.id) + "\n    ")]
                )
              }
            },
            {
              key: "name",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.detailGroup(props.row.id)
                      }
                    }
                  },
                  [_vm._v("\n      " + _vm._s(props.row.name) + "\n    ")]
                )
              }
            },
            {
              key: "count_apps",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.detailGroup(props.row.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(props.row.count_apps || 0) + "\n    "
                    )
                  ]
                )
              }
            },
            {
              key: "created_at",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.detailGroup(props.row.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.convertDateTime(props.row.created_at)) +
                        "\n    "
                    )
                  ]
                )
              }
            },
            {
              key: "updated_at",
              fn: function(props) {
                return _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.detailGroup(props.row.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.convertDateTime(props.row.updated_at)) +
                        "\n    "
                    )
                  ]
                )
              }
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: {
                        click: function($event) {
                          _vm.isModalAppGroupOpen(true)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.filterGroup(_vm.filter_data_group)
                        }
                      }
                    },
                    [
                      _c("j-select", {
                        staticClass: "m__r--5",
                        attrs: {
                          options: _vm.options_search_group,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type_group,
                          callback: function($$v) {
                            _vm.select_type_group = $$v
                          },
                          expression: "select_type_group"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-form-input", {
                        ref: "filterInputGroup",
                        staticStyle: { width: "250px", height: "35px" },
                        attrs: { placeholder: "Search" },
                        model: {
                          value: _vm.filter_data_group,
                          callback: function($$v) {
                            _vm.filter_data_group = $$v
                          },
                          expression: "filter_data_group"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appGroupModal",
          staticClass: "mod-form modal-app-type",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("j-modal-create-group", {
            on: { "modal-open": _vm.isModalAppGroupOpen }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e3b7364", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e3b7364","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/tabs/jApplicationGroupTab.vue
// module id = null
// module chunks = 